export default __webpack_public_path__ + "static/media/icon-download.157a998c.svg";